export class UserFilterDtoModel {
  constructor(searchReg: string) {
    this.searchReg = searchReg;
  }
  searchReg: string;
}
